import { render, staticRenderFns } from "./SocialItem.vue?vue&type=template&id=72b177ad&scoped=true"
import script from "./SocialItem.vue?vue&type=script&lang=js"
export * from "./SocialItem.vue?vue&type=script&lang=js"
import style0 from "./SocialItem.vue?vue&type=style&index=0&id=72b177ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b177ad",
  null
  
)

export default component.exports